import { render, staticRenderFns } from "./UpdateOrder.vue?vue&type=template&id=50f61ea7&scoped=true"
import script from "./UpdateOrder.vue?vue&type=script&lang=js"
export * from "./UpdateOrder.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrder.vue?vue&type=style&index=0&id=50f61ea7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f61ea7",
  null
  
)

export default component.exports